export const SCROLLSPY_LOCALE_ZHCHT = {
    guide: 'å°èª'
};
